import Is24CouponPng from '../images/IS24_Coupon.png';
import Is24CouponWebp from '../images/IS24_Coupon.webp';
import Is24CartPng from '../images/IS24_Cart.png';
import Is24CartWebp from '../images/IS24_Cart.webp';
import SmartphonePlayPng from '../images/smartphone_play.png';
import SmartphonePlayWebp from '../images/smartphone_play.webp';
import { useIntl } from '@/i18n/hooks/useIntl';
import { default as Msg } from '@/i18n/components/FormattedMessage';
import OrderedList from '@/components/common/display/orderedList/OrderedList';
import { ImageSource } from '@/components/common/display/imageSource/ImageSource';

export const HowItWorksTab = () => {
  const { t } = useIntl();
  const Item = OrderedList.Item;

  return (
    <div>
      <OrderedList>
        <Item
          image={
            <ImageSource
              image={Is24CouponPng}
              imageWebp={Is24CouponWebp}
              imageAlt={t({
                id: 'benefits.magentaTv.modal.howItWorks.image1',
                defaultMessage: 'IS24 Coupon',
              })}
              sizes='100px'
            />
          }
          text={t({
            id: 'benefits.magentaTv.modal.howItWorks.step1',
            defaultMessage:
              'Erstelle dir über “Gutschein holen” den Gutscheincode. Kopiere diesen und klicke auf „Code kopieren und Gutschein einlösen“',
          })}
        />
        <Item
          image={
            <ImageSource
              image={Is24CartPng}
              imageWebp={Is24CartWebp}
              imageAlt={t({
                id: 'benefits.magentaTv.modal.howItWorks.image2',
                defaultMessage: 'Scale',
              })}
              sizes='100px'
            />
          }
          text={t({
            id: 'benefits.magentaTv.modal.howItWorks.step2',
            defaultMessage:
              'Du wirst automatisch zum Warenkorb weiterleitet. Füge dort deinen Gutscheincode oben rechts ein und klicke auf „Weiter“.',
          })}
        />
        <Item
          image={
            <ImageSource
              image={SmartphonePlayPng}
              imageWebp={SmartphonePlayWebp}
              imageAlt={t({
                id: 'benefits.magentaTv.modal.howItWorks.image3',
                defaultMessage: 'Smartphone',
              })}
              sizes='100px'
            />
          }
          text={
            <Msg
              id='benefits.magentaTv.modal.howItWorks.step3'
              defaultMessage='Gehe zur Kasse, schließe den Bestellvorgang ab und genieße MagentaTV'
            />
          }
        />
      </OrderedList>
    </div>
  );
};
